import React from 'react';
import { Agreement } from '@/apis/agreement/interface';
import CheckBoxComponent from '@/components/CheckBoxComponent';
import styled from 'styled-components';

interface Props {
  agreement: Agreement;
  description?: string;
  onClick: () => void;
}

const ScrollSelectWrapper = ({ agreement, description, onClick }: Props) => {
  return (
    <>
      <SubHeaderWrapper>
        <SubHeader>
          <SubHeaderText>{agreement?.title} &nbsp;</SubHeaderText>
          {agreement?.isRequired && <Required>(필수)</Required>}
        </SubHeader>
        {agreement?.subtitle && (
          <SubHeaderDescription>{agreement?.subtitle}</SubHeaderDescription>
        )}
      </SubHeaderWrapper>
      <ScrollWrapper>
        <TermImage
          src={require(`../../../assets/images/agreement/${agreement?.image}`)}
        />
        <SelectWrapper>
          <CheckBoxComponent
            state={agreement?.isChecked}
            onClick={onClick}
            type={'small'}
            content={<SelectDescription>{description}</SelectDescription>}
          />
        </SelectWrapper>
      </ScrollWrapper>
    </>
  );
};

export default ScrollSelectWrapper;

const TermImage = styled.img`
  width: 100%;
  height: auto;
`;

const ScrollWrapper = styled.div`
  height: 335px;
  overflow-y: scroll;
  margin-bottom: 50px;
  padding: 20px;
  border: ${({ theme }) => `1px solid ${theme.DF_COLOR.GRAY100}`};
  border-radius: 4px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background: #ccc;
  }
`;

const SubHeaderWrapper = styled.div``;

const SubHeader = styled.h2`
  font-weight: 600;
  font-size: 18px;
  line-height: 23px;
  display: flex;
`;

const SubHeaderText = styled.p``;

const SubHeaderDescription = styled.p``;

const Required = styled.p`
  color: #ff8d00;
`;

const SelectWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 38px;
`;

const SelectDescription = styled.p`
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: black;
`;
